
<div class="flex flex-row items-center justify-between mt-2 mb-1">
  <p class="bottom-section-partner-name">Partner <span>{{ organization.name }}</span></p>
  <p v-if="city !== null && state !== null" class="bottom-section-location flex items-center"> 
    <img class="h-4" src="@/images/header/location_on_II.svg" alt="Service area location">
    {{ `${city}, ${state}` }}
  </p>
  <p v-else-if="organization.data['service_area']" class="bottom-section-location flex items-center"> 
    <img class="h-5" src="@/images/header/location_on_II.svg" alt="Service area location">
    {{ organization.data['service_area'] }}
  </p>
</div>      
